import { Link } from "react-router-dom";
import type { ArticleItem } from "@/mocks/articles";

export default function ArticleCard({ a }: { a: ArticleItem }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link to={`/article/${a.id}`} className="relative block aspect-[16/10] overflow-hidden bg-background-100">
        <img
          src={a.cover}
          alt={`${a.title} 内容配图`}
          title={`${a.title} - 51瓜网`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700 backdrop-blur-sm">
          {a.catName}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors md:text-lg">
          <Link to={`/article/${a.id}`} className="line-clamp-2 hover:text-primary-700">
            {a.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{a.excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {a.date}
            </span>
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-time-line"></i>
              {a.readTime} 分钟
            </span>
          </div>
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-fire-line"></i>
            {a.hot}
          </span>
        </div>
      </div>
    </article>
  );
}